import { CustomError } from '../../lib/custom-error';

export class PageNotFoundError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }

  message = 'Страница не найдена';
}

export class CmIdNotFoundError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }

  message = 'Отсутствует участник кампании';
}
